import FilterListIcon from "@material-ui/icons/FilterList";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { LOCKED_STATUS } from "app/common/LocalConst";
import { transformDate } from "app/common/LocalFunction";
import RegisterServiceHistoryPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/AllServicesTab/Popup/RegisterServiceHistoryPopup";
import PaymentVoucherPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/Popup/PaymentVoucherPopup";
import { lockService } from "app/services/ServiceRequestItemService";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
import LockRetainedPopup from "../FeeTab/Popup/LockRetainedPopup";
import RegisterServicePopup from "../RegisterServiceTreatmentPlanTab/Popup/RegisterServicePopup";
import ListAllServices from "./ListAllServices";
import ChangeServiceToClientCardPopup from "./Popup/ChangeServiceToClientCardPopup";
import HistoryServicePopup from "./Popup/HistoryServicePopup";
import HistoryTreatmentService from "./Popup/HistoryTreatmentService";
import UpdateMainServiceRegisterPopup from "./Popup/UpdateMainServiceRegisterPopup";
import UpdateTreatmentTotalPopup from "./Popup/UpdateTreatmentTotalPopup";
import WarrantyServiceInfoPopup from "./Popup/WarrantyServiceInfoPopup";
import SearchAllServices from "./SearchAllServices";

const AllServicesIndex = ({ tabValue }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  let [isOpenFillter, setOpenFillter] = useState(true);
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchService({
        ...searchAllServices,
        patientId,
        fromDate: null,
        toDate: null,
      });
      getListPaymentMethod();
      getTreatmentFree();
    }
  }, [patientId]);

  const searchValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  const {
    searchAllServices,
    handleChangeFormSearchService,
    openChangeServicePopup,
    handleCloseChangeServicePopup,
    initChangeService,
    handleSubmitChangeService,
    openCreateOrEditServicePopup,
    handleCloseCreateOrEditServicePopup,
    resetPopupStore,
    initRegisterService,
    openConfirmUnlock,
    handleConfirmUnlock,
    handleCloseConfirmUnlock,
    openConfirmError,
    handleOpenConfirmError,
    openConfirmDelete,
    handleDeleteService,
    handleOpenConfirmDelete,
    openRegisterServiceHistoryPopup,
    handleCloseRegisterServiceHistoryPopup,
    saveOrUpdateRegisterService,
    openConfirmLock,
    handleCloseConfirmLock,
    handleConfirmLock,
    treatmentFree,
    getTreatmentFree,
    openHistoryServicePopup,
    pageDataHistory,
    searchDataHistory,
    handleChangeFormSearchHistory,
    handleCloseHistoryServicePopup,
    openUpdateTotalTreatment,
    handleUpdateTotalTreatment,
    handleCloseUpdateTotalTreatmentPopup,
    openTreatmentTimesEachServicesConfirm,
    handleCloseGetTreatmentTimesEachServicesConfirm,
    handleGetTreatmentTimesEachServices,
    openHistoryTreamentServicePopup,
    handleCloseHistoryTreamentServicePopup,
    searchHistoryTreamentService,
    pageHistoryTreamentService,
    handleChangeFormSearchHistoryTreamentService,
    pagingAllServices,
    openFormMainServiceRegister,
    handleUpdateFormMainServiceRegister,
    initialMainServiceRegister,
    handleCloseFormMainServiceRegister,
    openWarrantyServicePopup,
    initialWarrantyService,
    handleCloseWarrantyServicePopup,
    pageAllServices,
  } = useStore().patientManagementStore.allServicesTabStore;
  const {
    listVatPercent,
    initialPatient,
    customerSourceWalkIn,
    handleGetPatientOverviewById,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;

  const {
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    openPaymentVoucherPopup,
    initialPaymentVoucher,
    createPaymentVoucherWithListMethod,
    listPaymentMethod,
    getListPaymentMethod,
    handleClosePaymentVoucherPopup,
    handleCloseTotalBillStatusInvoiceItemConfirm,
    openTotalBillStatusInvoiceItemConfirm,
    updateTotalBillStatusInvoiceItem,
    handleLockRetaind,
    openFormLockRetained,
    handleCloseFormLockRetaind,
    initialLockRetained,
  } = useStore().feeStore.serviceFeeTabStore;

  return (
    <section className="form-patient " style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342" }}>
        <Formik
          initialValues={searchAllServices}
          validationSchema={searchValidationSchema}
          onSubmit={(values) => {
            handleChangeFormSearchService(values);
          }}
          enableReinitialize
        >
          {({ values }) => {
            return (
              <Form autoComplete="off">
                <>
                  <div
                    className=" flex justify-between gap-2"
                    style={{ fontSize: "16px" }}
                  >
                    <p className="cards-header flex">
                      <span
                        className="flex items-center pointer"
                        style={{ fontWeight: "bold" }}
                      >
                        Tất cả dịch vụ
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        className="flex items-center"
                        onClick={() => setOpenFillter(!isOpenFillter)}
                      >
                        <FilterListIcon color="red" />
                      </span>
                    </p>

                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    ></div>
                  </div>

                  {!isOpenFillter && (
                    <>
                      <style>
                        {`
                    @keyframes slideDownFade {
                      0% {
                        opacity: 0;
                        transform: translateY(-10px);
                      }
                      100% {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                  `}
                      </style>
                      <div
                        style={{
                          animation: "slideDownFade 0.3s ease forwards",
                          zIndex: 10,
                          position: "relative",
                        }}
                      >
                        <SearchAllServices />
                      </div>
                    </>
                  )}

                  <ListAllServices />
                  {openChangeServicePopup && (
                    <ChangeServiceToClientCardPopup
                      handleClose={handleCloseChangeServicePopup}
                      open={openChangeServicePopup}
                      initChangeService={initChangeService}
                      listVatPercent={listVatPercent}
                      customerSourceWalkIn={customerSourceWalkIn}
                      onSubmit={handleSubmitChangeService}
                      treatmentFree={treatmentFree}
                      handleAfterSubmit={() =>
                        handleGetPatientOverviewByIdNotLoading(patientId)
                      }
                    />
                  )}
                  {!!openCreateOrEditServicePopup && (
                    <RegisterServicePopup
                      open={!!openCreateOrEditServicePopup}
                      handleClose={handleCloseCreateOrEditServicePopup}
                      resetPopupStore={resetPopupStore}
                      initRegisterService={{
                        ...initRegisterService,
                        patientId,
                      }}
                      listVatPercent={listVatPercent}
                      customerSourceWalkIn={customerSourceWalkIn}
                      onSubmit={saveOrUpdateRegisterService}
                    />
                  )}

                  {openConfirmUnlock && (
                    <ConfirmPopup
                      open={openConfirmUnlock}
                      onClose={handleCloseConfirmUnlock}
                      text="Bạn có muốn mở khóa dịch vụ không ?"
                      onConfirm={async () => {
                        await handleConfirmUnlock();
                        if (patientId) {
                          setTimeout(() => {
                            handleGetPatientOverviewByIdNotLoading(patientId);
                          }, 500);
                        }
                      }}
                    />
                  )}

                  {openConfirmLock && (
                    <ConfirmPopup
                      open={openConfirmLock}
                      onClose={handleCloseConfirmLock}
                      text="Bạn có muốn khóa dịch vụ không ?"
                      onConfirm={async () => {
                        await handleConfirmLock();
                        if (patientId) {
                          setTimeout(() => {
                            handleGetPatientOverviewByIdNotLoading(patientId);
                          }, 500);
                        }
                      }}
                    />
                  )}

                  {openConfirmError && (
                    <ConfirmPopup
                      open={openConfirmError}
                      onClose={handleOpenConfirmError}
                      text={openConfirmError}
                      isNotAPromise
                      hideConfirm
                    />
                  )}
                  {openConfirmDelete && (
                    <ConfirmPopup
                      open={openConfirmDelete}
                      onClose={() => handleOpenConfirmDelete(null)}
                      text="Bạn có chắc chắn muốn xóa dịch vụ này không ?"
                      onConfirm={async () => {
                        await handleDeleteService();
                        if (patientId) {
                          setTimeout(() => {
                            handleGetPatientOverviewByIdNotLoading(patientId);
                          }, 500);
                        }
                      }}
                    />
                  )}
                  {!!openRegisterServiceHistoryPopup && (
                    <RegisterServiceHistoryPopup
                      open={!!openRegisterServiceHistoryPopup}
                      handleClose={handleCloseRegisterServiceHistoryPopup}
                    />
                  )}

                  {openPaymentVoucherPopup && (
                    <PaymentVoucherPopup
                      open={openPaymentVoucherPopup}
                      handleClose={handleClosePaymentVoucherPopup}
                      initialPaymentVoucher={initialPaymentVoucher}
                      handleSubmit={async (values, setSubmitting) => {
                        const data = await createPaymentVoucherWithListMethod(
                          {
                            ...values,
                            notPaging: true,
                          },
                          setSubmitting
                        );
                        if (data?.responseStatus !== false) {
                          const servicesId = values?.patientServiceRegister?.id;
                          if (servicesId) {
                            const treatmentInList =
                              pageAllServices?.content?.find(
                                (item) => item?.id === servicesId
                              );
                            if (
                              treatmentInList?.activeStatus !== LOCKED_STATUS
                            ) {
                              await lockService(servicesId);
                            }
                          }
                          await handleGetPatientOverviewById(patientId);
                          await pagingAllServices();
                        }
                      }}
                      patient={initialPatient?.patientInfo}
                      listPaymentMethod={listPaymentMethod}
                      listStk={listStk}
                      listPos={listPos}
                      listHomecredit={listHomecredit}
                      listPos_tragop={listPos_tragop}
                    />
                  )}

                  {openHistoryServicePopup && (
                    <HistoryServicePopup
                      open={openHistoryServicePopup}
                      handleClose={handleCloseHistoryServicePopup}
                      searchData={searchDataHistory}
                      pageDataHistory={pageDataHistory}
                      handleChangeFormSearch={handleChangeFormSearchHistory}
                    />
                  )}
                  {openUpdateTotalTreatment && (
                    <UpdateTreatmentTotalPopup
                      open={openUpdateTotalTreatment}
                      handleClose={handleCloseUpdateTotalTreatmentPopup}
                      handleSubmit={handleUpdateTotalTreatment}
                    />
                  )}

                  {openTotalBillStatusInvoiceItemConfirm && (
                    <ConfirmPopup
                      open={openTotalBillStatusInvoiceItemConfirm}
                      onClose={handleCloseTotalBillStatusInvoiceItemConfirm}
                      text="Bạn có muốn tính số tiền và cập nhật trạng thái thanh toán không ?"
                      onConfirm={updateTotalBillStatusInvoiceItem}
                    />
                  )}

                  {openTreatmentTimesEachServicesConfirm && (
                    <ConfirmPopup
                      open={openTreatmentTimesEachServicesConfirm}
                      onClose={handleCloseGetTreatmentTimesEachServicesConfirm}
                      text="
                      LƯU Ý: Hệ thống sẽ tự tính toán lại số lần đã thực hiện = tổng số điều trị của dịch vụ này. Và sắp xếp lại lần điều trị của các điều trị theo thời gian
                      "
                      onConfirm={handleGetTreatmentTimesEachServices}
                    />
                  )}

                  {openHistoryTreamentServicePopup && (
                    <HistoryTreatmentService
                      open={openHistoryTreamentServicePopup}
                      handleClose={handleCloseHistoryTreamentServicePopup}
                      searchData={searchHistoryTreamentService}
                      pageDataHistory={pageHistoryTreamentService}
                      handleChangeFormSearch={
                        handleChangeFormSearchHistoryTreamentService
                      }
                    />
                  )}
                  {openFormLockRetained && (
                    <LockRetainedPopup
                      handleClose={handleCloseFormLockRetaind}
                      initialValues={initialLockRetained}
                      onConfirm={handleLockRetaind}
                      open={openFormLockRetained}
                      handleAfterSubmit={() => {
                        pagingAllServices();
                        setTimeout(() => {
                          handleGetPatientOverviewByIdNotLoading(patientId);
                        }, 400);
                      }}
                    />
                  )}

                  {openFormMainServiceRegister && (
                    <UpdateMainServiceRegisterPopup
                      handleClose={handleCloseFormMainServiceRegister}
                      initialValues={initialMainServiceRegister}
                      onConfirm={handleUpdateFormMainServiceRegister}
                      open={openFormMainServiceRegister}
                      handleAfterSubmit={pagingAllServices}
                    />
                  )}
                  {openWarrantyServicePopup && (
                    <WarrantyServiceInfoPopup
                      dataService={initialWarrantyService}
                      handleClose={handleCloseWarrantyServicePopup}
                      open={openWarrantyServicePopup}
                    />
                  )}
                </>
              </Form>
            );
          }}
        </Formik>
      </div>
    </section>
  );
};

export default memo(observer(AllServicesIndex));
